import {action, makeObservable, observable, reaction} from "mobx";
import {
    hideBonusWinAmountBoard,
    setBonusWinAmountBoardAmount,
    setBuyFreeBetBoardClickable,
    setBuyFreeBetBoardVisible, showBonusWinAmountBoard, showTextWinFreeSpins, updateFreeBetBoard
} from "../freeSpin";
import {setVisibleForSomeControlPanelItems, updateSpinBtnState} from "../controlPanel";
import {spinControlPanel} from "../slotBoard/spin";
import {hideBonusBackground} from "../slotBoard/createSlotBoard";
import {hideFreeSinsLeftInfoText} from "../controlPanel/amountText";
import {getAmountWithCurrency} from "../utilites";
import {store} from "./store";
import {t, TKeys} from "../translationService";
import {spinStore} from "./spinStore";
import {pixiComponents} from "../index";
import {freeBetGame} from "../freeBetGame";

class FreeSpinStore {
    isBonusGameStarted = false;
    canBuyFreeSpin = true;
    freeSpin = null;

    constructor() {
        makeObservable(this, {
            isBonusGameStarted: observable,
            canBuyFreeSpin: observable,
            freeSpin: observable,
            setFreeSpin: action,
            setCanBuyFreeSpin: action,
            setIsBonusGameStarted: action,
        });
    }

    setBonusGameWinAmount(amount){
        this.freeSpin.winAmount = amount;
    }

    setFreeSpinsUsedQuantity(quantity){
        this.freeSpin.usedQuantity = quantity;
    }

    setFreeSpin(data) {
        this.freeSpin = data;
    }

    setCanBuyFreeSpin(bool) {
        this.canBuyFreeSpin = bool;
    }

    setIsBonusGameStarted(bool) {
        this.isBonusGameStarted = bool;
    }
}

export const freeSpinStore = new FreeSpinStore();

reaction(
    () => freeSpinStore.canBuyFreeSpin,
    (canBuyFreeSpin) => {
        setBuyFreeBetBoardClickable(canBuyFreeSpin);
        updateFreeBetBoard();
    }
);

reaction(
    () => freeSpinStore.isBonusGameStarted,
    (isBonusGameStarted) => {
        isBonusGameStarted && freeBetGame.freezeForBonusGame();
        setBuyFreeBetBoardVisible(!isBonusGameStarted);
        setVisibleForSomeControlPanelItems(!isBonusGameStarted);
        updateSpinBtnState(spinControlPanel);
        pixiComponents.slotBoard.multipliersBoard.totalMultiplayerComponent.setTotalMultiplier(0);
        if (!isBonusGameStarted) {
            spinControlPanel.isAutoSpinning = false;
            spinStore.setAutoSpinCountdown(0);
            updateSpinBtnState(spinControlPanel);
            if(store.isDemo()){
                spinStore.setUserBalance(spinStore.userBalance+freeSpinStore.freeSpin.winAmount);
            }else{
                spinStore.setUserBalanceFromBackend();
            }
            showTextWinFreeSpins(`${t(TKeys.YOU_WON)} \n ${getAmountWithCurrency(freeSpinStore.freeSpin.winAmount.toFixed(2), store.currency)}`);
            hideBonusBackground();
            hideFreeSinsLeftInfoText();
            hideBonusWinAmountBoard();
            freeSpinStore.setFreeSpin(null);
            pixiComponents.slotBoard.setInitialBackground();
            pixiComponents.slotBoard.multipliersBoard.totalMultiplayerComponent.setTransparency(0);
            pixiComponents.slotBoard.multipliersBoard.totalMultiplayerComponent.setTotalMultiplier(0);
            freeBetGame.resumeAfterBonusGame();
        }
    }
);

